import { useHasPermission } from '../../hooks/useHasPermission';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/roles/rolePageHeader.css';

const RegionPageHeader = ({ setOpenAddRegion }) => {

    const { t } = useTranslation();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const hasRegionCreatePermission = useHasPermission('region_create');

    const handleAddRegion = useCallback(() => {
        setOpenAddRegion(true);
    }, [setOpenAddRegion]);

    return (
        <Box className='role_page_header_main_container'>
            <Box className='role_page_header_title_box'>
                <Typography className='role_page_header_page_title'>{t("Regions")}</Typography>
            </Box>
            {isDesktop && hasRegionCreatePermission &&
                <Box className='role_page_header_action_box' onClick={handleAddRegion}>
                    <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='role_page_header_action_title'>{t("addRegionDialogeTitle")}</Typography>
                </Box>
            }
            {!isDesktop &&
                <Box className='role_page_header_action_box'>
                    {hasRegionCreatePermission && <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} onClick={handleAddRegion} />}
                </Box>
            }
        </Box>
    );
};

export default React.memo(RegionPageHeader);